import angular from 'angular'

// components
import editSegmentVariables from './component/editSegmentVariables.component'

export default angular
  .module('portalApp.manage.editSegmentVariables', [])
  .component('editSegmentVariables', editSegmentVariables)
  .name
